import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import NumberField from "../../../components/Fields/NumberField";
import SelectListField from "../../../components/Fields/SelectListField";
import SwitchField from "../../../components/Fields/SwitchField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { ItemTypePopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";

interface ItemTypeItemStatusType {
    itemTypeId: number | undefined
    itemStatusTypeId: number
    displayOrder: number
    isMainStatusType: boolean
}

const AddItemTypeAttachmentTypePopup: React.FC<ItemTypePopupProps> = ({ show, onHide, itemTypeId }) => {
    const [serverErrors, setServerErrors] = useState<DataResult<ItemTypeItemStatusType>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<ItemTypeItemStatusType>({
        itemTypeId: itemTypeId,
        itemStatusTypeId: 0,
        displayOrder: 0,
        isMainStatusType: false
    });

    const itemStatusTypes = useSelectListOptions('api/v1/selectlist/ItemStatusTypes', '-- Select itemstatus type');

    function submit() {
        if (formData) {
            DataService
                .create<ItemTypeItemStatusType>(`api/v1/itemTypeItemStatusTypes/`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true && response.data)
                        setFormData(response.data);

                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'itemStatusTypeId', label: 'Status type', labelSize: 4, validationRules: [{ type: 'isRequired' }] },
            { name: 'displayOrder', label: 'Display order', labelSize: 4, validationRules: [{ type: 'isNumber' }, { type: 'isMinValue', minValue: 0 }] },
            { name: 'isMainStatusTypeId', label: 'Is Main status type', labelSize: 4 },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add itemstatus type'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('itemStatusTypeId')} options={itemStatusTypes} />
                <NumberField {...getFieldProps('displayOrder')} />
                <SwitchField {...getFieldProps('isMainStatusTypeId')} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Add' />
            </Popup.Footer>
        </Popup>
    );
}
export default AddItemTypeAttachmentTypePopup;